export var Forms;

(function (Forms) {})(Forms || (Forms = {}));